import { useEffect, useState } from 'react'
import { Field, change, formValueSelector, isDirty } from 'redux-form'
import { DateAndTimePicker } from '../../../itrust_common/components/form'
import { dateTimeFormat, getProcedureTime, getTimeDuration } from '../../../itrust_common/components/HelperFunctions'
import { connect, useDispatch } from 'react-redux'
import DateFormatView from '../../../itrust_common/components/others/DateFormatView'
import useOrgDateFormat from '../../../itrust_common/components/others/helperHooks/useOrgDateFormat'
import { nextAvailableSlotLoad } from '../../../redux/actions/appointmentActions'
import { quickActions } from '../../../redux/actions/dashboard/quickActionActions'

function AppointmentStartEndTime(props) {
  const { selectedStartTime, selectedEndTime, selectedProcedures, procedures, timeSlotFrequency, appointmentEditing, isAppointmentFormDirty, isFullMode, isQuickAction, appointmentStaffId } = props
  const dispatch = useDispatch()
  const [invalidSlot, setInvalidSlot] = useState(false)
  const dateFormat = useOrgDateFormat()

  useEffect(() => {
    return () => {
      isQuickAction && dispatch(quickActions({ select_patient_modal: false }))
    }
  }, [])

  useEffect(() => {
    if (isQuickAction) {
      setStartTime(appointmentStaffId ? { staff_id: appointmentStaffId } : {})
    }
  }, [appointmentStaffId])

  const setStartTime = async (filter) => {
    let res = await dispatch(nextAvailableSlotLoad(filter))
    dispatch(change('appointmentForm', 'start_time', new Date(res.value.data.start_time)))
    dispatch(change('appointmentForm', 'end_time', new Date(res.value.data.end_time)))
  }

  const handleOnProcedureChange = () => {
    if (selectedProcedures?.length) {
      let procedureDuration = getProcedureTime({ procedures, selectedProcedures })
      procedureDuration = procedureDuration === 0 ? timeSlotFrequency : procedureDuration
      invalidSlot && setInvalidSlot(false)
      const endTime = (appointmentEditing.id && appointmentEditing.id !== "New" && !isAppointmentFormDirty) ? selectedEndTime : new Date(new Date(selectedStartTime).getTime() + procedureDuration * 60000);
      return endTime
    }
    return selectedEndTime
  }

  const updateEndTimeDate = (startTime, originalEndTime) => {
    let endTime = new Date(startTime);
    endTime.setHours(originalEndTime.getHours(), originalEndTime.getMinutes(), 0, 0); // Keep 11:00 AM
    return new Date(endTime.toString());
  }

  const handleSlotDuration = () => {
    const endTime = updateEndTimeDate(new Date(selectedStartTime), new Date(selectedEndTime), new Date(selectedStartTime));
    if (new Date(selectedEndTime).getTime() !== endTime.getTime()) {
      dispatch(change('appointmentForm', 'end_time', endTime));
    }
    // let isValidDuration = new Date(selectedStartTime) < new Date(endTime)
    // if (!isValidDuration) {
    //   Alert.warning("Appointment duration cannot be zero or less.")
    //   !invalidSlot && setInvalidSlot(true)
    // }
    // else {
    //   invalidSlot && setInvalidSlot(false)
    // }
  }

  useEffect(() => {
    let endTime = handleOnProcedureChange()
    dispatch(change('appointmentForm', 'end_time', endTime))
  }, [selectedProcedures, selectedStartTime])

  useEffect(() => {
    selectedStartTime && handleSlotDuration()
  }, [selectedStartTime, selectedEndTime])

  return (
    <div className="bg-light py-3 pr-5 mb-5 mx-1 row">
      <div className={`${isFullMode ? 'col-12' : 'col-6 '} pr-0 appointment-slot-field position-relative`}>
        <Field label="Start Time" name="start_time" component={DateAndTimePicker} timeSlotDuration={5} wrapperClasses="w-100" />
        <span className='time position-absolute text-nowrap' title={dateTimeFormat(selectedStartTime, '', dateFormat)}>
          <DateFormatView dateTime={selectedStartTime} />
        </span>
      </div>
      <div className={`${isFullMode ? 'col-12' : 'col-6 '} pr-0 appointment-slot-field position-relative`}>
        <Field label="End Time" name="end_time" component={DateAndTimePicker} timeSlotDuration={5} wrapperClasses="w-100" />
        <span className='time position-absolute text-nowrap' title={dateTimeFormat(selectedEndTime, '', dateFormat)}>
          <DateFormatView dateTime={selectedEndTime} />
        </span>
      </div>
      <span className={`col-12 mt-3 ${invalidSlot ? 'text-danger' : 'text-muted'}`}>Appointment Duration : {getTimeDuration(selectedStartTime, selectedEndTime)}</span>
    </div>
  )
}

const selector = formValueSelector('appointmentForm');

const mapStateToProps = (state) => {
  const { setting: { calendarSetting }, appointment } = state
  const selectedStartTime = selector(state, 'start_time')
  const selectedEndTime = selector(state, 'end_time')
  const appointmentStaffId = selector(state, 'staff_id')
  const selectedProcedures = selector(state, 'procedure_ids')
  return {
    selectedStartTime,
    selectedEndTime,
    selectedProcedures,
    timeSlotFrequency: calendarSetting?.calendar_setting?.time_slot_frequency,
    appointmentEditing: appointment.editing,
    isFullMode: appointment.handlerData.isFullMode,
    appointmentStaffId,
    isAppointmentFormDirty: isDirty('appointmentForm')(state),
  }
}

export default connect(mapStateToProps)(AppointmentStartEndTime)